module.exports = {
  dispute_txn: {
    disputeResonArr: [
      { value: 1, text: 'This transaction is a duplicate key' },
      { value: 2, text: 'Did not receive ATM Cash' }, // ATM_CASH_NOT_DISPENSED
      { value: 3, text: "I don't recognize this transaction" }, // UNRECOGNISED_TXN
      { value: 4, text: 'Incorrect transaction amount recorded' }, // INCORRECT_TXN_AMOUNT
      { value: 5, text: 'Reversal not processed' }, // REVERSAL_NOT_PROCESSED
      { value: 6, text: 'This is a failed transaction' }, // FAILED_TXN
      { value: 7, text: 'Someone else used your card without permission' }, // CARD_USED_WITHOUT_PERMISSION
      { value: 8, text: 'Fraudulent transaction' }, // FRAUDULENT_TXN
      { value: 9, text: 'Services not rendered or merchandise not received' }, // SERVICE_NOT_RENDERED
      { value: 10, text: 'Credit not processed' }, // CREDIT_NOT_PROCESSED
      {
        value: 11,
        text: 'Transaction amount differs from the agreed upon amount', // TXN_AMOUNT_MISMATCH
      },
      { value: 12, text: 'Cancelled recurring transaction' }, // CANCELLED_RECURRING
    ],
    disputeInfo: {
      UNRECOGNISED_TXN:
        'Neither me nor my colleagues incurred or authorized this transaction',
      FAILED_TXN:
        'Payment failed but money has been debited from my happay card',
    },
    atmDisputeReasons: {
      1: 'Cash not dispensed',
      2: 'Partial amount dispensed',
    },
  },
  expenseFilters: {
    '/invoice/myinvoice':{
      saved: { name: 'Saved', key: 'Saved', value: '' },
      all: { name: 'All', key: 'All', value: '' },
      // pending: { name: 'Pending', key: 'Pending', value: '' },
      // approved: { name: 'Paid', key: 'Paid', value: '' },
    },
    '/invoice/myapproval':{
      pending: { name: 'Pending', key: 'Pending', value: '' },
      history: { name: 'History', key: 'History', value: '' },
      all: { name: 'All', key: 'All', value: '' },
      // approved: { name: 'Paid', key: 'Paid', value: '' },
    },
    '/vendor/myvendor':{
      saved: { name: 'Saved', key: 'Saved', value: '' },
      all: { name: 'All', key: 'All', value: '' },
      // inactive: { name: 'Inactive', key: 'Inactive', value: '' },
      // pending: { name: 'Pending', key: 'Pending', value: '' },
      // approved: { name: 'Approved', key: 'Approved', value: '' },
    },
    '/vendor/myapproval':{
      pending: { name: 'Pending', key: 'Pending', value: '' },
      history: { name: 'History', key: 'History', value: '' },
      all: { name: 'All', key: 'All', value: '' },
      // approved: { name: 'Approved', key: 'Approved', value: '' },
      // otherapprovals: { name: 'Other approvals', key: 'other_approvals', value: '' },
    },
    invoiceNativeFilters:[
      {
        field_type: "text",
        display_name: "Invoice System ID",
        meta_id: "invoice_id",
        is_hidden: false
      },
      {
        field_type: "daterange",
        display_name: "Invoice Date",
        meta_id: "daterange",
        is_hidden: false
      },
      {
        field_type: "text",
        display_name: "Vendor Registration Name",
        meta_id: "vendor_name",
        is_hidden: false
      },
      {
        field_type: "text",
        display_name: "Vendor Identification ID",
        meta_id: "vendor_identification_id",
        is_hidden: false
      },
      {
        field_type: "dropdown",
        behaviour: "multiselect",
        display_name: "Approval Status",
        meta_id: "approval_status",
        filter_context: "OTHER",
        url: "custom-status/v1/invoice-status-choice/",
        is_hidden: false
      },
      {
        field_type: "text",
        display_name: "Vendor System ID",
        meta_id: "vendor_id",
        is_hidden: false
      },
      {
        field_type: "text",
        display_name: "Vendor Display Name",
        meta_id: "vendor_display_name",
        is_hidden: false
      },
    ],
    vendorNativeFilters:[
      {
        field_type: "text",
        display_name: "Vendor System ID",
        meta_id: "vendor_id",
        is_hidden: false
      },
      {        
        field_type: "daterange",
        display_name: "Creation Date",
        meta_id: "daterange",
        is_hidden: false
      },
      {
        field_type: "text",
        display_name: "Vendor Display Name",
        meta_id: "display_name",
        is_hidden: false
      },
      {
        field_type: "text",
        display_name: "Identification ID",
        meta_id: "identification_id",
        is_hidden: false
      },
      {
        field_type: "dropdown",
        behaviour: "multiselect",
        display_name: "Approval Status",
        filter_context: "OTHER",
        url: "custom-status/v1/vendor-status-choice/",
        meta_id: "approval_status",
        is_hidden: false
      },
    ],
    invoiceApproval:{
      All:'all_view_approval_invoice',
      Pending:'pending_on_me_invoices',
      History:'actioned_by_me_invoices',
    },
    vendorApproval:{
      All:'all_view_approval_vendor',
      Pending:'pending_on_me_vendors',
      History:'actioned_by_me_vendors',
    },
    myInvoice:{
      All:'all_view_invoice',
      Saved:'saved_invoices',
    },
    myVendor:{
      All:'all_view_vendor',
      Saved:'saved_vendors',
    }
  },
};
